import { portalEvents } from "./PortalEvents"
import Alerts from "./PortalAlerts.vue"

export default {
  install(Vue, options) {
    Vue.component("Alerts", Alerts)

    Vue.config.globalProperties.$alert = (o) => {
      portalEvents.emit("show", {
        type: "alert",
        ...(typeof o === "object" ? o : { text: o, title: "Alert" }),
      })
    }

    Vue.config.globalProperties.$confirm = (o) => {
      portalEvents.emit("show", {
        type: "confirmation",
        ...(typeof o === "object" ? o : {}),
      })
    }
  },
}
